import { useMutation } from "@tanstack/react-query";
import { chargeHours } from "../api/timeEntryApi";

// Carga horas de forma automática (semana / mes) o descriptiva (POST time-entry/charge-hours).
// El componente maneja onSuccess / onError para Swal y recarga de datos.
export const useChargeHours = () =>
  useMutation({
    mutationFn: chargeHours,
  });
